import { DashboardModule } from '@domain-group/suit-theme'

import QuotesImageUrl from './assets/quotes.svg'

const QuotesBlankState = () => (
  <DashboardModule.BlankState boxProps={{ border: 'none' }} imageUrl={QuotesImageUrl}>
    <DashboardModule.BlankState.Title>No Matching Quotes</DashboardModule.BlankState.Title>

    <DashboardModule.BlankState.Paragraph>
      You can create quotes to present the costs of a marketing campaign to a user or customer. You&apos;ll be
      able to create quotes from saved templates, or existing campaign quotes.
    </DashboardModule.BlankState.Paragraph>
  </DashboardModule.BlankState>
)

export default QuotesBlankState
